import type { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';

import { AppServerResponse } from '../../utils/interfaces/generalInterfaces';
import { UserLoginAttemptsInitialState } from '../globalSlices/userLoginAttemptsSlice';
import {
  getSupplierPendingUserLoginAttemptsCount,
  getSupplierUserLoginAttempts,
  rejectUserLoginAttempt,
} from '../services/userLoginAttemptsService';

export const getSupplierUserLoginAttemptsExtraReducer = (
  builder: ActionReducerMapBuilder<UserLoginAttemptsInitialState>
) => {
  const reducerId = 'getSupplierUserLoginAttempts';
  builder.addCase(getSupplierUserLoginAttempts.pending, (state) => {
    state.loadingList = [...new Set([...state.loadingList, reducerId])];
  });
  builder.addCase(
    getSupplierUserLoginAttempts.fulfilled,
    (state, action: PayloadAction<AppServerResponse | null>) => {
      state.loadingList = state.loadingList.filter((item) => item !== reducerId);
      if (action.payload && action.payload.success && action.payload?.data) {
        state.userLoginAttempts = action.payload?.data;
        state.supplierPendingUserLoginAttemptsCount = (action.payload?.data || []).length;
      }
    }
  );
  builder.addCase(getSupplierUserLoginAttempts.rejected, (state) => {
    state.loadingList = state.loadingList.filter((item) => item !== reducerId);
  });
};

export const getSupplierPendingUserLoginAttemptsCountExtraReducer = (
  builder: ActionReducerMapBuilder<UserLoginAttemptsInitialState>
) => {
  const reducerId = 'getSupplierPendingUserLoginAttemptsCount';
  builder.addCase(getSupplierPendingUserLoginAttemptsCount.pending, (state) => {
    state.loadingList = [...new Set([...state.loadingList, reducerId])];
  });
  builder.addCase(
    getSupplierPendingUserLoginAttemptsCount.fulfilled,
    (state, action: PayloadAction<AppServerResponse | null>) => {
      state.loadingList = state.loadingList.filter((item) => item !== reducerId);
      if (action.payload && action.payload.success) {
        state.supplierPendingUserLoginAttemptsCount = Number(action.payload?.data?.count ?? 0);
      }
    }
  );
  builder.addCase(getSupplierPendingUserLoginAttemptsCount.rejected, (state) => {
    state.loadingList = state.loadingList.filter((item) => item !== reducerId);
  });
};

export const rejectUserLoginAttemptExtraReducer = (
  builder: ActionReducerMapBuilder<UserLoginAttemptsInitialState>
) => {
  const reducerId = 'rejectUserLoginAttempt';
  builder.addCase(rejectUserLoginAttempt.pending, (state) => {
    state.loadingList = [...new Set([...state.loadingList, reducerId])];
  });
  builder.addCase(rejectUserLoginAttempt.fulfilled, (state, action) => {
    state.loadingList = state.loadingList.filter((item) => item !== reducerId);
    if (action.payload && action.payload.success) {
      // Drop the rejected row locally so the badge and table update without a refetch
      const { userLoginAttemptId } = action.meta.arg;
      state.userLoginAttempts = state.userLoginAttempts.filter(
        (attempt) => attempt.id !== userLoginAttemptId
      );
      state.supplierPendingUserLoginAttemptsCount = state.userLoginAttempts.length;
    }
  });
  builder.addCase(rejectUserLoginAttempt.rejected, (state) => {
    state.loadingList = state.loadingList.filter((item) => item !== reducerId);
  });
};
